import { assetUrl } from '@utils/assetUrl'

export const MUSIC_FILES = {
  CRASH_BG_MUSIC: assetUrl('audio/music/CRASH_BG_MUSIC.mp3'),
  DEFENDER_BG_MUSIC: assetUrl('audio/music/DEFENDER_BG_MUSIC.mp3'),
  HOWZZAT_BG_MUSIC: assetUrl('audio/music/HOWZZAT_BG_MUSIC.mp3'),
}
